module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-3.26ce6f6e.svg";